import { render, staticRenderFns } from "./Prompt.vue?vue&type=template&id=36b1d5df&scoped=true&"
import script from "./Prompt.vue?vue&type=script&lang=js&"
export * from "./Prompt.vue?vue&type=script&lang=js&"
import style0 from "./Prompt.vue?vue&type=style&index=0&id=36b1d5df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b1d5df",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("Q:\\Projects\\dnx-dpn\\MarketingDb.Web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('36b1d5df')) {
      api.createRecord('36b1d5df', component.options)
    } else {
      api.reload('36b1d5df', component.options)
    }
    module.hot.accept("./Prompt.vue?vue&type=template&id=36b1d5df&scoped=true&", function () {
      api.rerender('36b1d5df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Components/Util/Prompt.vue"
export default component.exports